"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./sis-notification-box.component.css");
var controls_translation_service_1 = require("../shared/controls-translation.service");
var NotificationBoxComponent = /** @class */ (function () {
    function NotificationBoxComponent(translationService) {
        this.translationService = translationService;
        this.modeText = null;
        this.onHide = new core_1.EventEmitter();
    }
    NotificationBoxComponent.prototype.ngOnInit = function () {
        this.modes = ['Default', 'Success', 'Warning', 'Error', 'Custom'];
    };
    NotificationBoxComponent.prototype.hideNotification = function () {
        this.clearTimeouts();
        this.onHide.emit();
    };
    NotificationBoxComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes && changes.visible && changes.visible.currentValue) {
            this.fadeOutCall = setTimeout(function () {
                _this.fadeOut = true;
            }, 7000);
            this.fadeOut = setTimeout(function () {
                _this.visible = false;
                _this.onHide.emit();
            }, 7400);
        }
    };
    NotificationBoxComponent.prototype.ngOnDestroy = function () {
        this.clearTimeouts();
    };
    NotificationBoxComponent.prototype.clearTimeouts = function () {
        this.visible = false;
        if (this.fadeOut)
            clearTimeout(this.fadeOut);
        if (this.fadeOutCall)
            clearTimeout(this.fadeOutCall);
    };
    NotificationBoxComponent.prototype.getMessage = function (key) {
        return this.translationService && this.translationService.getMessage(key);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NotificationBoxComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NotificationBoxComponent.prototype, "mode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NotificationBoxComponent.prototype, "modeText", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NotificationBoxComponent.prototype, "message", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NotificationBoxComponent.prototype, "visible", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NotificationBoxComponent.prototype, "color", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NotificationBoxComponent.prototype, "icon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NotificationBoxComponent.prototype, "hide", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], NotificationBoxComponent.prototype, "onHide", void 0);
    NotificationBoxComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-notification-box',
            template: require('./sis-notification-box.component.html'),
        }),
        __param(0, core_1.Optional()),
        __metadata("design:paramtypes", [controls_translation_service_1.ControlsTranslationService])
    ], NotificationBoxComponent);
    return NotificationBoxComponent;
}());
exports.NotificationBoxComponent = NotificationBoxComponent;
//# sourceMappingURL=sis-notification-box.component.js.map